import { render, staticRenderFns } from "./CollegeDetail.vue?vue&type=template&id=586d0681&"
import script from "./CollegeDetail.vue?vue&type=script&lang=js&"
export * from "./CollegeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports